
const cssCode = `
    .grid-parent:has(#\${values._meta.htmlID}) {
        display: grid;
        column-gap: \${values.column_gap}px;
        row-gap: \${values.row_gap}px;
        grid-template-columns:repeat(\${values.column_count}, 1fr);
        grid-template-rows:repeat(\${values.row_count}, 1fr);
    }

    div:has(> .grid-trigger) {
        display: none;
    }
`;

export default `
unlayer.registerTool({
    name: 'grid',
    label: 'Grid merge tags',
    icon: 'fa-grid',
    supportedDisplayModes: ['web'],
    options: {
        default: {
            position: 1,
            options: {
                column_count: {
                    label: 'Column count',
                    defaultValue: '1',
                    widget: 'counter'
                },
                row_count: {
                    label: 'Row count',
                    defaultValue: '1',
                    widget: 'counter'
                },
                column_gap: {
                    label: 'Column gap (in pixel)',
                    defaultValue: '10',
                    widget: 'counter'
                },
                row_gap: {
                    label: 'Row gap (in pixel)',
                    defaultValue: '10',
                    widget: 'counter'
                }
            }
        }
    },
    values: {},
    renderer: {
        Viewer: unlayer.createViewer({
            render(values) {
                return "<span class='grid-trigger'>";
            }
        }),
        exporters: {
            web: function (values) {
                return "<span class='grid-trigger'>";
            }
        },
        head: {
            css: function (values) {
                return \`${cssCode}\`;
            }
        }
    }
});`;
